module.exports = __webpack_public_path__ + "img/LOGOss.4c3dce5a.png";